@if (enabled()) {
@let currentUrl = this.currentUrl();
@let currentLanguage = this.currentLanguage();
@let isHomePage = currentUrl === '/main/home';
@let withLanguageSelection = this.withLanguageSelection();
@let withBrightnessSelection = this.withBrightnessSelection();
@let pageIdsWithCallWaiter = this.pageIdsWithCallWaiter();
@let items = this.items();

<div
  class="tab-bar"
  [class.hide]="hideTabBar()"
  coreActivitySection="TabBar"
>
  @let withPreferences = withLanguageSelection || withBrightnessSelection;
  @let longList = withPreferences ? items.length > 3 : items.length > 4;

  <div
    class="items with-preferences"
    #itemsElement
  >
    @if (withLanguageSelection || withBrightnessSelection) {
      @let isActivePreferences = !isHomePage && currentUrl.startsWith('/main/preferences');

      <button
        @fadeIn
        class="item-button"
        [class.small]="longList"
        [class.active]="isActivePreferences"
        [routerLink]="isActivePreferences ? ['/', 'main', 'home'] : ['/', 'main', 'preferences']"
        [queryParams]="isActivePreferences ? [] : { ref: 'tab-bar' }"
        coreUserActivityClickTracking="Open Preferences"
      >
        @if (withBrightnessSelection) {
          <svg
            class="icon"
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="currentColor"
          >
            <path
              d="M8 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0 1a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM8 0a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 0zm0 13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 13zm8-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5zM3 8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2A.5.5 0 0 1 3 8zm10.657-5.657a.5.5 0 0 1 0 .707l-1.414 1.415a.5.5 0 1 1-.707-.708l1.414-1.414a.5.5 0 0 1 .707 0zm-9.193 9.193a.5.5 0 0 1 0 .707L3.05 13.657a.5.5 0 0 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0zm9.193 2.121a.5.5 0 0 1-.707 0l-1.414-1.414a.5.5 0 0 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .707zM4.464 4.465a.5.5 0 0 1-.707 0L2.343 3.05a.5.5 0 1 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .708z"
            />
          </svg>
        }

        @if (withLanguageSelection) {
          <div class="icon-text">{{ ('labelShort' | translate).toUpperCase() }}</div>
        }
      </button>
    }

    @for (item of items; track item.id) {
      @if (item.type === 'image') {
        <div
          @fadeIn
          class="item-image"
          [style.--item-width]="item.theme?.width | sizeTranslate: currentLanguage"
          [style.--item-background-color]="item.theme?.background?.color | colorTranslate: currentLanguage"
          [style.--item-border-radius]="item.theme?.border?.radius | sizeTranslate: currentLanguage"
        >
          <app-image
            class="image"
            [image]="item.image | imageTranslate: currentLanguage"
            [alt]="item.name"
          />
        </div>
      }

      @if (item.type === 'button' && item.action.type === 'page') {
        @let isActive = !isHomePage && isActivePage(currentUrl, item.action.pageId);
        @let labelFallback = item.label.normal | textTranslate:'fallback';

        <button
          @fadeIn
          class="item-button"
          [class.active]="isActive"
          [style.--item-width]="item.theme?.width?.normal | sizeTranslate: currentLanguage"
          [style.--item-background-color]="item.theme?.background?.color?.normal | colorTranslate: currentLanguage"
          [style.--item-foreground-color]="item.theme?.foreground?.color?.normal | colorTranslate: currentLanguage"
          [style.--item-border-color]="item.theme?.border?.color?.normal | colorTranslate: currentLanguage"
          [style.--item-border-radius]="item.theme?.border?.radius?.normal | sizeTranslate: currentLanguage"
          [style.--item-active-width]="item.theme?.width?.active | sizeTranslate: currentLanguage"
          [style.--item-active-background-color]="item.theme?.background?.color?.active | colorTranslate: currentLanguage"
          [style.--item-active-foreground-color]="item.theme?.foreground?.color?.active | colorTranslate: currentLanguage"
          [style.--item-active-border-color]="item.theme?.border?.color?.active | colorTranslate: currentLanguage"
          [style.--item-active-border-radius]="item.theme?.border?.radius?.active | sizeTranslate: currentLanguage"
          [routerLink]="isActive ? ['/', 'main', 'home'] : ['/', 'main', 'page', item.action.pageId]"
          [queryParams]="isActive ? [] : { ref: 'tab-bar' }"
          [coreUserActivityClickTracking]="isActive ? `Close ${ labelFallback }` : `Open ${ labelFallback }`"
        >
          @if (item.icon) {
            @let icon = (
              isActive && item.icon.active
                ? item.icon.active
                : item.icon.normal
            ) | imageTranslate: currentLanguage;

            <app-image
              class="icon"
              [image]="icon"
              [alt]="labelFallback"
            />
          }

          @if (isActive && item.label.active) {
            <app-text @fadeIn class="label">{{ item.label.active | textTranslate: currentLanguage }}</app-text>
          } @else {
            <app-text @fadeIn class="label">{{ item.label.normal | textTranslate: currentLanguage }}</app-text>
          }

          @if (pageIdsWithCallWaiter?.includes(item.action.pageId)) {
            <app-call-waiter-indicator class="indicator"/>
          }
        </button>
      }

      @if (item.type === 'image-button' && item.action.type === 'page') {
        @let isActive = !isHomePage && isActivePage(currentUrl, item.action.pageId);

        <button
          @fadeIn
          class="item-button with-image"
          [class.active]="isActive"
          [style.--item-width]="item.theme?.width?.normal | sizeTranslate: currentLanguage"
          [style.--item-background-color]="item.theme?.background?.color?.normal | colorTranslate: currentLanguage"
          [style.--item-border-color]="item.theme?.border?.color?.normal | colorTranslate: currentLanguage"
          [style.--item-border-radius]="item.theme?.border?.radius?.normal | sizeTranslate: currentLanguage"
          [style.--item-active-width]="item.theme?.width?.active | sizeTranslate: currentLanguage"
          [style.--item-active-background-color]="item.theme?.background?.color?.active | colorTranslate: currentLanguage"
          [style.--item-active-border-color]="item.theme?.border?.color?.active | colorTranslate: currentLanguage"
          [style.--item-active-border-radius]="item.theme?.border?.radius?.active | sizeTranslate: currentLanguage"
          [routerLink]="isActive ? ['/', 'main', 'home'] : ['/', 'main', 'page', item.action.pageId]"
          [queryParams]="isActive ? [] : { ref: 'tab-bar' }"
          [coreUserActivityClickTracking]="isActive ? `Close ${ item.name }` : `Open ${ item.name }`"
        >
          @let image = (
            isActive && item.image.active
              ? item.image.active
              : item.image.normal
          ) | imageTranslate: currentLanguage;

          <app-image
            class="image"
            [image]="image"
            [alt]="item.name"
          />

          @if (pageIdsWithCallWaiter?.includes(item.action.pageId)) {
            <app-call-waiter-indicator class="indicator"/>
          }
        </button>
      }
    }
  </div>
</div>

@if (hideTabBar() && hasTabs()) {
  <app-interaction-prompt/>
}
}
